import React, { useState, useEffect } from 'react'
import {
    useAppSelector,
    isRunningInWebview,
    postMessageToWebview,
    HybridEventType
} from '@thriveglobal/thrive-web-core'

function useTokenExchange() {
    const tokens = useAppSelector((state) => state.auth)
    const user = useAppSelector((state) => state.user)

    const [tokenSent, setTokenSent] = useState<boolean>(false)

    useEffect(() => {
        if (
            isRunningInWebview() &&
            tokens?.tokenExpiration &&
            tokens?.accessToken &&
            tokens?.accessTokenExpiration &&
            user?.companyId &&
            user?.userId
        ) {
            postMessageToWebview({
                type: HybridEventType.LOGIN,
                value: {
                    thriveToken: {
                        token: tokens.accessToken,
                        exp: tokens.tokenExpiration
                    },
                    accessToken: {
                        token: tokens.accessToken,
                        exp: tokens.accessTokenExpiration
                    },
                    refreshToken: {
                        token: tokens.refreshToken,
                        exp: tokens.refreshTokenExpiration
                    },
                    companyId: user.companyId,
                    userId: user.userId
                }
            })
            setTokenSent(true)
        }
    }, [tokens])

    return tokenSent
}

export default useTokenExchange
